import React from "react";
import CampaignLogo from "../../assets/campaign-logo.svg"

export interface MenuProps {
  section: "hypes" | "actors-and-directors";
  locale: any;
  onItemClick: () => void;
}

export const Menu: React.FC<MenuProps> = ({ section, locale, onItemClick }) => {
  const l: any = locale;
  return <div className="menu">
    <div className="menu__campaign-logo">
      <img src={CampaignLogo} alt="" />
    </div>
    <nav className="menu__nav">
      <ul className="menu__nav-list">
        <li className={`menu__nav-item ${section === "hypes" && "menu__nav-item--active"}`}>
          <h1 onClick={onItemClick}>
            <a href="#/content/hypes">{l["hypeTitle"]}</a>
          </h1>
        </li>
        <li className={`menu__nav-item ${section === "actors-and-directors" && "menu__nav-item--active"}`}>
          <h1 onClick={onItemClick}>
            <a href="#/content/actors-and-directors">{l["actorsTitle"]}</a>
          </h1>
        </li>
      </ul>
    </nav>
  </div>
}